import { Component, Event, EventEmitter, h, Method, Prop } from "@stencil/core";
import { TableDataColumnType } from "../interface";
import { TableDataCell } from "../table-data-cell/table-data-cell";
import { TableDataHeader } from "../table-data-header/table-data-header";

@Component({
    tag: "ux-table-data-column-checkbox",
    styleUrl: "table-data-column-checkbox.scss",
    shadow: false
})
export class TableDataColumnCheckbox implements TableDataColumnType {
    /**
     * Defines which field of the table will be displayed in the column.
     */
    @Prop() readonly field: string;
    /**
     * Defines the label of the table column.
     */
    @Prop() readonly label: string;
    /**
     * Defines if the column should be a group.
     */
    @Prop() readonly group: boolean = false;
    /**
     * Defines if the column should be sortable.
     */
    @Prop() readonly sortable: boolean = false;
    /**
     * Defines if the checkbox should be editable.
     */
    @Prop() readonly editable: boolean = false;

    /**
     * Makes the render function public.
     */
    @Method()
    async getColumnMethods() {
        return {
            renderCell: this.renderCell.bind(this),
            renderHeader: this.renderHeader.bind(this),
            getSortString: this.getSortString.bind(this)
        };
    }

    /**
     * Triggered when a checkbox is changed.
     */
    @Event({
        eventName: "uxCheckboxChange",
        composed: true,
        cancelable: true,
        bubbles: true
    })
    checkboxAction!: EventEmitter;

    private getCheckboxChangeHandler = (row: object) => (event: Event) => {
        const checked = (event.target as HTMLUxCheckboxElement).checked;
        this.checkboxAction.emit({
            checked,
            row,
            field: this.field
        });
    };

    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    private getSortString(row: any) {
        const { field } = this;
        return field === "" ? "" : row[field] ? "1" : "0";
    }

    private renderHeader() {
        return <TableDataHeader label={this.label} sortable={this.sortable} sortField={this.field} group={this.group} />;
    }

    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    private renderCell(row: any) {
        const { field, group, editable } = this;
        const empty = field === "";
        return (
            <TableDataCell group={group}>
                {!empty && <ux-checkbox onChange={this.getCheckboxChangeHandler(row)} disabled={!editable} checked={row[field]} />}
            </TableDataCell>
        );
    }
}
